/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ActionInstance} from "./action-instance";
import {EmGroup} from "./em-group";
import {Event} from "./event";
import {RuleCondition} from "./rule-condition";
import {LocationInstance} from "./location-instance";
import {ZoneInstance} from "./zone-instance";

export class Rule {
  id: number;
  event: Event;
  name: string;
  description: string;
  type: RuleType;
  group: string;
  deactivationEvent: Event;
  deactivationThreshold: number;
  activationEvent: Event;
  activationThreshold: number;
  creationDate: Date;
  modifiedDate: Date;
  startTime: string;
  endTime: string;
  uuid: string;
  isActive: boolean;
  actions: ActionInstance[];
  conditions: RuleCondition[]
  locations: LocationInstance[];
  zones: ZoneInstance[];
  days: string[];
  groups: EmGroup[];
}

export enum RuleType {
  DRL = "DRL",
  DSL = "DSL"
}
